import _regeneratorRuntime from "/app/packages/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { combineReducers } from 'redux';
import { schema, normalize } from 'normalizr';
import ReduxThunk from 'redux-thunk';
import { produce } from 'immer';
import { createContext, createElement, useContext } from 'react';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var internals = {};

var _export_create_ = function _export_create_(_ref) {
  var createStore = _ref.createStore,
      _ref$mods = _ref.mods,
      mods = _ref$mods === void 0 ? {} : _ref$mods;
  var middleEnd = {
    initialized: false,
    initialize: function initialize() {
      if (middleEnd.initialized !== false) {
        return middleEnd;
      }

      middleEnd.initialized = null; // Initialize props

      Object.values(internals.pickEach(middleEnd.mods, 'schema')).forEach(function (schema$1) {
        Object.values(schema$1).filter(function (item) {
          return item instanceof schema.Entity;
        }).forEach(function (entity) {
          entity.relatedFields = function () {
            var _exports;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return (_exports = exports).relatedFields.apply(_exports, args.concat([{
              idAttribute: entity.idAttribute
            }]));
          };

          if (entity.relations) {
            entity.define(entity.relations(schema$1));
          }
        });
      }); // Run mod initializers

      Object.values(middleEnd.mods).filter(function (mod) {
        return mod && mod.initialize;
      }).forEach(function (mod) {
        return mod.initialize(middleEnd, mod);
      });
      middleEnd.initialized = true;
      return middleEnd;
    }
  };

  var initializedProp = function initializedProp(key, initializer) {
    Object.defineProperty(middleEnd, key, {
      configurable: true,
      enumerable: true,
      get: function get() {
        if (middleEnd.initialized === false) {
          throw new Error("Cannot access property \"".concat(key, "\" until middle-end is initialized."));
        }

        var value = initializer();
        Object.defineProperty(middleEnd, key, {
          value: value,
          writable: true
        });
        return value;
      }
    });
  };

  initializedProp('mods', function () {
    return typeof mods === 'function' ? mods() : mods;
  });
  initializedProp('store', function () {
    var reducer = combineReducers(internals.pickEach(middleEnd.mods, 'reducer'));
    return createStore(reducer, middleEnd.mods);
  });
  initializedProp('getState', function () {
    return middleEnd.store.getState;
  });
  initializedProp('dispatch', function () {
    var dispatch = function dispatch() {
      var _middleEnd$store;

      return (_middleEnd$store = middleEnd.store).dispatch.apply(_middleEnd$store, arguments);
    }; // Convenient dispatch,
    // dispatch.auth.login() versus dispatch(actions.auth.login())


    Object.entries(middleEnd.actions).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          modName = _ref3[0],
          actions = _ref3[1];

      dispatch[modName] = {};
      Object.entries(actions).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            actionName = _ref5[0],
            action = _ref5[1];

        dispatch[modName][actionName] = function () {
          return dispatch(action.apply(void 0, arguments));
        };
      });
    });
    return dispatch;
  });
  initializedProp('actions', function () {
    return internals.pickEach(middleEnd.mods, 'actions');
  });
  initializedProp('select', function () {
    var selectors = middleEnd.selectors,
        getState = middleEnd.getState; // Convenient selection,
    // select.auth.isAuthenticated() versus selectors.auth.isAuthenticated(getState())

    return internals.mapEachLeafFunction(selectors, function (selector) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return selector.apply(void 0, [getState()].concat(args));
      };
    });
  });
  initializedProp('selectors', function () {
    return internals.pickEach(middleEnd.mods, 'selectors');
  });
  return middleEnd;
};

var _export_middleware_ = {
  thunk: ReduxThunk,
  errorLogger: function errorLogger() {
    return function (next) {
      return function (action) {
        var type = action.type,
            error = action.error,
            payload = action.payload,
            meta = action.meta;

        if (error) {
          console.error("Error from action \"".concat(type, "\""), meta, '\n', payload);
        }

        return next(action);
      };
    };
  }
};

var _export_relatedFields_ = function _export_relatedFields_(entity, fields) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref6$idAttribute = _ref6.idAttribute,
      idAttribute = _ref6$idAttribute === void 0 ? 'id' : _ref6$idAttribute;

  var subEntity = _defineProperty({}, idAttribute, entity[idAttribute]);

  fields.forEach(function (field) {
    if (entity.hasOwnProperty(field)) {
      subEntity[field] = entity[field];
    }
  });
  return Object.keys(subEntity).length > 1 ? subEntity : undefined;
};

internals.pickEach = function (obj, prop) {
  return Object.entries(obj).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        value = _ref8[1];

    return value && typeof value[prop] !== 'undefined';
  }).reduce(function (collect, _ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, key, value[prop]));
  }, {});
};

internals.mapEachLeafFunction = function (obj, map) {
  return Object.entries(obj).reduce(function (collect, _ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        key = _ref12[0],
        value = _ref12[1];

    return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, key, typeof value === 'function' ? map(value) : value && _typeof(value) === 'object' ? internals.mapEachLeafFunction(value, map) : value));
  }, {});
};

var internals$1 = {};

var _export_createAction_ = function _export_createAction_(actionTypes, config) {
  if (typeof actionTypes === 'string') {
    return internals$1.simpleAction(actionTypes, config);
  }

  return internals$1.asyncAction(actionTypes, config);
};

internals$1.simpleAction = function (actionType) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof config === 'function') {
    config = {
      transform: config
    };
  }

  var _config = config,
      _config$transform = _config.transform,
      transform = _config$transform === void 0 ? internals$1.defaultTransform : _config$transform;
  return function () {
    return {
      type: actionType,
      payload: transform.apply(void 0, arguments)
    };
  };
};

internals$1.asyncAction = function (actionTypes) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof config === 'function') {
    config = {
      handler: config
    };
  }

  var _config2 = config,
      _config2$handler = _config2.handler,
      handler = _config2$handler === void 0 ? internals$1.defaultTransform : _config2$handler,
      _config2$transform = _config2.transform,
      transform = _config2$transform === void 0 ? internals$1.defaultTransform : _config2$transform,
      after = _config2.after,
      schema = _config2.schema,
      _config2$index = _config2.index,
      indexed = _config2$index === void 0 ? false : _config2$index;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
        var beginPayload, computedArgs, index, successPayload, error;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                beginPayload = transform.apply(void 0, args);
                computedArgs = [].concat(beginPayload);

                index = function () {
                  if (!indexed) {
                    return null;
                  }

                  if (typeof indexed === 'string') {
                    return indexed;
                  }

                  if (typeof indexed === 'function') {
                    return indexed.apply(void 0, _toConsumableArray(computedArgs));
                  }

                  return actionTypes.BASE;
                }();

                _context.prev = 3;
                dispatch({
                  type: actionTypes.BEGIN,
                  payload: beginPayload,
                  meta: {
                    index: index
                  }
                });
                _context.next = 7;
                return handler.apply(void 0, _toConsumableArray(computedArgs));

              case 7:
                successPayload = _context.sent;

                if (schema) {
                  successPayload = normalize(successPayload, schema);
                }

                dispatch({
                  type: actionTypes.SUCCESS,
                  payload: successPayload,
                  meta: {
                    original: beginPayload,
                    index: index
                  }
                }); // after will possibly fire async

                if (after) {
                  after({
                    original: beginPayload,
                    result: successPayload
                  });
                }

                return _context.abrupt("return", [null, successPayload]);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                error = internals$1.ensureError(_context.t0);
                dispatch({
                  type: actionTypes.FAIL,
                  payload: error,
                  error: true,
                  meta: {
                    original: beginPayload,
                    index: index
                  }
                });
                return _context.abrupt("return", [error]);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};

internals$1.defaultTransform = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length <= 1) {
    return args[0];
  }

  return args;
};

internals$1.ensureError = function (obj) {
  if (obj instanceof Error) {
    return obj;
  }

  var error = new Error(obj.message);
  error.data = obj;
  return error;
};

var _export_type_ = {
  async: {
    isAsync: true
  },
  simple: {
    isSimple: true
  }
};

var _export_createTypes_ = function _export_createTypes_(prefix, config) {
  if (!config) {
    config = prefix;
    prefix = null;
  }

  prefix = prefix ? "".concat(prefix, "/") : '';
  return Object.entries(config).reduce(function (collect, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        type = _ref2[1];

    var base = "".concat(prefix).concat(name);

    if (type.isAsync) {
      return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, name, {
        BASE: base,
        BEGIN: "".concat(base, "/BEGIN"),
        SUCCESS: "".concat(base, "/SUCCESS"),
        FAIL: "".concat(base, "/FAIL")
      }));
    }

    if (type.isSimple || type === true) {
      return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, name, base));
    }

    return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, name, type));
  }, {});
};

var _export_isTypeOfBase_ = function _export_isTypeOfBase_(type, base) {
  return type.startsWith("".concat(base, "/")) || type === base;
};

var _export_isTypeBegin_ = function _export_isTypeBegin_(type) {
  return type.endsWith('/BEGIN');
};

var _export_isTypeSuccess_ = function _export_isTypeSuccess_(type) {
  return type.endsWith('/SUCCESS');
};

var _export_isTypeFail_ = function _export_isTypeFail_(type) {
  return type.endsWith('/FAIL');
};

var internals$2 = {};

var _export_createReducer_ = function _export_createReducer_(config, initialState, handlers) {
  if (typeof handlers === 'undefined') {
    handlers = initialState;
    initialState = config;
    config = {};
  }

  if (handlers.hasOwnProperty('undefined')) {
    throw new Error('Reducer has an undefined handler. Ensure that all actions used in this reducer exist.');
  }

  var _config = config,
      _config$mutable = _config.mutable,
      mutable = _config$mutable === void 0 ? false : _config$mutable;

  if (mutable) {
    handlers = _objectSpread2({}, handlers);
    Object.keys(handlers).forEach(function (key) {
      handlers[key] = produce(handlers[key]);
    });
  }

  var initialize = function initialize(s) {
    return typeof s === 'function' ? s() : s;
  };

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialize(initialState);
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }

    return state;
  };
};

var _export_createEntityReducer_ = function _export_createEntityReducer_() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$schema = _ref.schema,
      schema = _ref$schema === void 0 ? {} : _ref$schema,
      _ref$shouldMerge = _ref.shouldMerge,
      shouldMerge = _ref$shouldMerge === void 0 ? internals$2.defaultShouldMerge : _ref$shouldMerge,
      _ref$shouldIndex = _ref.shouldIndex,
      shouldIndex = _ref$shouldIndex === void 0 ? true : _ref$shouldIndex;

  var shouldMergeFn = typeof shouldMerge === 'function' ? shouldMerge : function () {
    return shouldMerge;
  };
  var shouldIndexFn = typeof shouldIndex === 'function' ? shouldIndex : function () {
    return shouldIndex;
  };
  return combineReducers({
    indexes: function indexes() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
          type = _ref2.type,
          payload = _ref2.payload,
          error = _ref2.error,
          meta = _ref2.meta;

      if (!meta || !meta.index || !shouldIndexFn(meta.index)) {
        return state;
      }

      return produce(state, function (draft) {
        var index = draft[meta.index] = draft[meta.index] || {
          original: undefined,
          result: undefined,
          error: null,
          inFlight: 0
        };

        if (_export_isTypeBegin_(type)) {
          index.inFlight++;
          index.original = payload;
        }

        if (_export_isTypeSuccess_(type) || _export_isTypeFail_(type)) {
          index.inFlight--;

          if (meta.hasOwnProperty('original')) {
            index.original = meta.original;
          }
        }

        if (_export_isTypeSuccess_(type)) {
          // In case of normalized result, ignore entities and just take result
          index.result = internals$2.isNormalizedPayload(payload) ? payload.result : payload;
          index.error = null;
        }

        if (error) {
          index.error = payload || true;
        }
      });
    },
    // Keeps a dictionary of entities by key and id
    entities: function entities() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : internals$2.getInitialEntityState(schema);

      var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
          payload = _ref3.payload,
          error = _ref3.error;

      if (error || !internals$2.isNormalizedPayload(payload)) {
        return state;
      }

      return produce(state, function (draft) {
        var entities = payload.entities;
        Object.keys(entities).forEach(function (entityKey) {
          if (!state[entityKey]) {
            return;
          }

          Object.keys(entities[entityKey]).forEach(function (id) {
            var entity = entities[entityKey][id];

            if (shouldMergeFn(entity)) {
              draft[entityKey][id] = draft[entityKey][id] || {}; // Preserve parts of an entity we've seen in past actions, but not this one
              // We'll use forEach because Object.assign would set those aforementioned parts to undefined

              Object.entries(entity).forEach(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    key = _ref5[0],
                    val = _ref5[1];

                if (typeof val !== 'undefined') {
                  draft[entityKey][id][key] = val;
                }
              });
            } else {
              draft[entityKey][id] = entity;
            }
          });
        });
      });
    }
  });
};

internals$2.defaultShouldMerge = function (entity) {
  return Boolean(entity._top);
};

internals$2.getInitialEntityState = function (schema$1) {
  return Object.values(schema$1).filter(function (entity) {
    return entity instanceof schema.Entity;
  }).reduce(function (collect, entity) {
    return _objectSpread2(_objectSpread2({}, collect), {}, _defineProperty({}, entity.key, {}));
  }, {});
};

internals$2.isNormalizedPayload = function (payload) {
  return payload && payload.hasOwnProperty('result') && payload.entities;
};

var Context = createContext();
Context.displayName = 'StrangeMiddleEnd';

var _export_Provider_ = function Provider(_ref) {
  var middleEnd = _ref.middleEnd,
      children = _ref.children;

  if (!middleEnd || !middleEnd.initialized) {
    throw new Error('StrangeMiddleEnd.Provider received an unitialized middle-end. Please pass an initialized middle-end.');
  }

  return createElement(Context.Provider, {
    value: middleEnd
  }, children);
};

var _export_useMiddleEnd_ = function useMiddleEnd() {
  var m = useContext(Context);

  if (!m) {
    throw new Error('No middle-end found. Make sure this component is wrapped in strange-middle-end\'s <Provider>.');
  }

  return m;
};

var _export_create_$1 = _export_create_;
var _export_middleware_$1 = _export_middleware_;
var _export_relatedFields_$1 = _export_relatedFields_;
var _export_createAction_$1 = _export_createAction_;
var _export_createTypes_$1 = _export_createTypes_;
var _export_type_$1 = _export_type_;
var _export_isTypeOfBase_$1 = _export_isTypeOfBase_;
var _export_isTypeBegin_$1 = _export_isTypeBegin_;
var _export_isTypeSuccess_$1 = _export_isTypeSuccess_;
var _export_isTypeFail_$1 = _export_isTypeFail_;
var _export_createReducer_$1 = _export_createReducer_;
var _export_createEntityReducer_$1 = _export_createEntityReducer_;
var _export_Provider_$1 = _export_Provider_;
var _export_useMiddleEnd_$1 = _export_useMiddleEnd_;
export { _export_Provider_$1 as Provider, _export_create_$1 as create, _export_createAction_$1 as createAction, _export_createEntityReducer_$1 as createEntityReducer, _export_createReducer_$1 as createReducer, _export_createTypes_$1 as createTypes, _export_isTypeBegin_$1 as isTypeBegin, _export_isTypeFail_$1 as isTypeFail, _export_isTypeOfBase_$1 as isTypeOfBase, _export_isTypeSuccess_$1 as isTypeSuccess, _export_middleware_$1 as middleware, _export_relatedFields_$1 as relatedFields, _export_type_$1 as type, _export_useMiddleEnd_$1 as useMiddleEnd };